<div class="container-fluid">
    <div class="row pt-4">
        <div class="col-sm-6" [ngClass]="
                this.updatedtheme === 'dark' ? 'headlinetextD' : 'headlinetextL'
            ">
            <h3 class="pl-4">Users</h3>
        </div>
    </div>

    <div class="row d-flex justify-content-between mx-3 pt-3">
        <div class="col-7 myCol overflow-auto mb-5" style="height: 76vh !important;"
            [ngClass]="this.updatedtheme === 'dark' ? 'User-tabD' : 'User-tabL'">
            <div class="row p-2">
                <div class="" [ngClass]="
                        this.updatedtheme === 'dark'
                            ? 'User-headD'
                            : 'User-headL'
                    ">
                    <div class="d-flex align-items-center gap-3">
                        <p class="ml-3 ct_fw_600">Users List</p>
                        <div class="ct_how_use_tooltip_main ml-auto">
                            <i class="fa-solid fa-circle-question" (click)="isHowtoUse = !isHowtoUse"></i>
                            <div class="ct_how_use_tooltip_cnt" [ngClass]="isHowtoUse ? 'ct_active' : ''">
                                <div>
                                    <p class="mb-1 ">There are five types of users with different access rights in the
                                        tool. This access control system ensures that users have appropriate permissions
                                        to view and edit data based on their role and responsibilities within the
                                        organization.
                                    </p>
                                    <h5 class="ct_fs_16 mt-3">1. Super-Admin:

                                    </h5>

                                    <ol style="list-style: none;" class="mb-0">
                                        <li>- Has read and edit rights to all sections of the tool, which can be
                                            accessed as a part of the package taken by the company

                                        </li>
                                        <li>- Only Super-Admin has access to the 'Tree' and 'set GHG template' section
                                        </li>
                                        <li>- Can add users as Admins, Managers, and Data Preparers
                                        </li>
                                        <li>- Works with Ekobon team to set up organization tree and save GHG templates
                                            of Scope1, 2 &3 sub-categories relevant for different facilities.
                                        </li>
                                    </ol>

                                    <h5 class="ct_fs_16  mt-3">2. Admin:

                                    </h5>
                                    <ol style="list-style: none;" class="mb-2">
                                        <li>- Has read and edit rights to associated sub-group and facilities
                                        </li>
                                        <li>- Admin of main group has access to all sub-groups and facilities

                                        </li>
                                        <li>- Can add users as Admins, Managers, and Data Preparers for
                                            sub-groups/facilities they have access to
                                        </li>
                                    </ol>
                                    <h5 class="ct_fs_16  mb-0 mt-3">3. Manager:


                                    </h5>
                                    <ol style="list-style: none;" class="mb-2">
                                        <li> - Has read and edit rights only to associated facility

                                        </li>
                                        <li>- Can add other Managers and Data Preparers for specific facility

                                        </li>

                                    </ol>

                                    <h5 class="ct_fs_16 mt-3 ">4. Data Preparer:</h5>
                                    <ol class="mb-2" style="list-style: none;">
                                        <li> - Has read and edit rights only to associated facility

                                        </li>
                                        <li> - Cannot add any users

                                        </li>

                                    </ol>
                                    <h5 class="ct_fs_16 mb-2 mt-3 ">5. Auditor</h5>
                                    <ol class="mb-2" style="list-style: none;">
                                        <li> - Has read only rights to all sections of the tool, which can be accessed
                                            as a
                                            part of the package taken by the company

                                        </li>
                                        <li> - Can access, generate and download the audits report located in the
                                            reporting section

                                        </li>

                                    </ol>
                                    <h5 class="ct_fs_16 ">Additionally, there are specific access rights for GHG
                                        Emissions and Financed Emissions:

                                    </h5>
                                    <ol class="mb-2" style="list-style: none;">
                                        <li> - GHG Emissions:

                                            <ul style="list-style: none;">
                                                <li>- Reported at facility level

                                                </li>
                                                <li> - Can be entered by Super-Admin, Admin, Manager, or Data Preparer
                                                </li>

                                            </ul>
                                        </li>
                                        <li> - Financed Emissions:

                                            <ul style="list-style: none;">
                                                <li> - Reported at sub-group level
                                                </li>
                                                <li> - Only Admins can input data for financed emissions of associated
                                                    sub-group
                                                </li>

                                            </ul>
                                        </li>

                                    </ol>
                                </div>






                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between text-style text-light scope-Div">
                    <div class="form-group has-search">
                        <span class="fa fa-search form-control-feedback" [ngClass]="
                                this.updatedtheme === 'dark'
                                    ? 'form-control-feedbackD'
                                    : 'form-control-feedbackL'
                            ">
                        </span>
                        <input type="text" name="search" [ngClass]="
                                this.updatedtheme === 'dark'
                                    ? 'form-controlD'
                                    : 'form-controlL'
                            " class="form-control text-white" placeholder="Search user" [(ngModel)]="inputText" (input)="onSearch(inputText)" />
                    </div>
                    <div class="form-group has-search text-light ml-2" *ngIf="loginInfo.role != 'Preparer'">
                        <button class="UserButton ct_animation_btn_121 mt-0 ct_assign_package_btn129"
                            (click)="showDialog()" (click)="AddUser()">
                            Add User
                        </button>
                    </div>
                </div>
            </div>

            <p-toast></p-toast>
            <p-confirmDialog #cd [style]="{width: '60vw'}">
                <ng-template pTemplate="footer">
                    <button pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"
                        class="span-color cancel-button"></button>
                    <button pButton icon="pi pi-times" label="Cancel" (click)="cd.reject()"
                        class="p-button-raised p-button-danger"></button>
                </ng-template>
            </p-confirmDialog>

            <p-dialog (click)="removeCss()" [(visible)]="visible" [breakpoints]="{'960px': '75vw'}"
                [style]="{width: '80vw'}" [closable]="false">
                <p-header *ngIf="FormEdit === false"> Add New User </p-header>
                <p-header *ngIf="FormEdit === true"> Edit User </p-header>

                <div class="modal-body text-white text-style Dashboard-tab mt-0 ct_modal_scrool_121">
                    <form #UserForm="ngForm" (ngSubmit)="onSubmit(UserForm.value)" class="col-12">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label for="fname" class="text-dark">First name</label>
                                    <input ngModel name="firstName" id="search-input" id="form1" type="text"
                                        class="form-control Dashboard-tab text-white" placeholder="First Name"
                                        #firstName="ngModel" [disabled]="isloading" [(ngModel)]="admininfo.firstname"
                                        required firstName />
                                    <p class="text-danger mb-0"
                                        *ngIf="UserForm.submitted && firstName.errors?.['required']">
                                        First name required
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label for="fname" class="text-dark">Last name</label>
                                    <input ngModel name="lastName" id="search-input" type="text"
                                        class="form-control Dashboard-tab text-white" placeholder="Last Name"
                                        [(ngModel)]="admininfo.lastname" [disabled]="isloading" #lastName="ngModel"
                                        required />
                                    <p class="text-danger" *ngIf="UserForm.submitted && lastName.errors?.['required']">
                                        last name required
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label for="fname" class="text-dark">User name</label>
                                    <input ngModel name="username" id="search-input" id="form1" placeholder="UserName"
                                        type="text" class="form-control Dashboard-tab text-white" #username="ngModel"
                                        [disabled]="isloading" [(ngModel)]="admininfo.username" (change)="
                                        CheckUserExist(admininfo.username, 'username')
                                    " required />
                                    <p class="text-danger mb-0"
                                        *ngIf="UserForm.submitted && username.errors?.['required']">
                                        user name required
                                    </p>
                                    <p class="text-danger mb-0" *ngIf="usernameIsExist === true && username.touched">
                                        user name already taken please use other
                                    </p>
                                </div>

                            </div>
                            <div class="col-md-6">
                                <div class="mb-3">
                                    <label for="fname" class="text-dark">Email</label>
                                    <input ngModel name="email" id="search-input" type="text" placeholder="Email"
                                        class="form-control Dashboard-tab text-white" [(ngModel)]="admininfo.email"
                                        (change)="CheckUserExist(admininfo.email, 'email')" #email="ngModel"
                                        [disabled]="isloading" required />
                                    <p class="text-danger mb-0"
                                        *ngIf="UserForm.submitted && email.errors?.['required']">
                                        email required
                                    </p>
                                    <p class="text-danger mb-0" *ngIf="emailIstExist === true && email.touched">
                                        user already exist for this email please use other
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-12" *ngIf="FormEdit === false">
                                <div class="mb-3">
                                    <label for="fname" class="text-dark">Password</label>
                                    <input ngModel name="password" id="search-input" type="text"
                                        placeholder="Enter password" class="form-control Dashboard-tab text-white"
                                        [(ngModel)]="admininfo.password" #password="ngModel" [disabled]="FormEdit"
                                        required />
                                    <p class="text-danger mb-0"
                                        *ngIf="UserForm.submitted && password.errors?.['required']">
                                        password required
                                    </p>
                                    <!-- <p class="text-danger mb-0" *ngIf="emailIstExist === true && email.touched">
                                        user already exist for this email please use other
                                    </p> -->
                                </div>
                            </div>
                        </div>

                        <label for="fname" class="text-dark">Role</label>
                        <div>
                            <div class="row d-flex mt-2">
                                <div *ngFor="let Role of RolesList" class="mb-3 px-3">

                                    <div class="d-flex align-items-center gap-2 flex-wrap" style="gap:10px">
                                        <ng-container *ngIf="loginInfo.role == 'Super Admin'">
                                            <p-radioButton ngModel [inputId]="Role.Id" name="Role" [value]="Role.Id"
                                                (click)="onSelected(Role.Id)"
                                                [(ngModel)]="admininfo.roleID"></p-radioButton>


                                            <div>
                                                <p *ngIf="Role.Name =='Admin'" style="font-size: 16px; color: #88AD47;">
                                                    Admin
                                                    <br> Access to the sub group and all facilities
                                                </p>
                                                <p *ngIf="Role.Name =='Manager'"
                                                    style="font-size: 16px; color: #88AD47;" class="mb-0">
                                                    Manager <br> Access to the associated facility</p>
                                                <p *ngIf="Role.Name =='Preparer'"
                                                    style="font-size: 16px; color: #88AD47;" class="mb-0">
                                                    Preparer <br> Access to the associated facility</p>
                                                <p *ngIf="Role.Name =='Auditor'"
                                                    style="font-size: 16px; color: #88AD47;" class="mb-0">
                                                    Auditor <br> Access to the Audit Report</p>
                                                <!-- <p style="font-size: 16px; color: #88AD47;" *ngIf="Role.Name == 'Approver'">
                                                Approver</p> -->

                                            </div>

                                        </ng-container>
                                        <ng-container *ngIf="loginInfo.role == 'Admin'">
                                            <ng-container *ngIf="Role.Id != 'a34d0ecf-4730-4521-82ee-5e3eg28bdfb0'">
                                                <p-radioButton ngModel [inputId]="Role.Id" name="Role" [value]="Role.Id"
                                                    (click)="onSelected(Role.Id)"
                                                    [(ngModel)]="admininfo.roleID"></p-radioButton>

                                            </ng-container>


                                            <div>
                                                <p *ngIf="Role.Name =='Admin'" style="font-size: 16px; color: #88AD47;">
                                                    Admin
                                                    <br> Access to the sub group and all facilities
                                                </p>
                                                <p *ngIf="Role.Name =='Manager'"
                                                    style="font-size: 16px; color: #88AD47;" class="mb-0">
                                                    Manager <br> Access to the associated facility</p>
                                                <p *ngIf="Role.Name =='Preparer'"
                                                    style="font-size: 16px; color: #88AD47;" class="mb-0">
                                                    Preparer <br> Access to the associated facility</p>
                                                <!-- <p style="font-size: 16px; color: #88AD47;" *ngIf="Role.Name == 'Approver'">
                                            Approver</p> -->

                                            </div>

                                        </ng-container>
                                        <ng-container *ngIf="loginInfo.role == 'Manager'">
                                            <p-radioButton
                                                *ngIf="Role.Name !='Admin' && Role.Id !== 'a34d0ecf-4730-4521-82ee-5e3eg28bdfb0'"
                                                ngModel [inputId]="Role.Id" name="Role" [value]="Role.Id"
                                                (click)="onSelected(Role.Id)" [(ngModel)]="selectedRole"
                                                [disabled]="isloading"></p-radioButton>

                                            <div>

                                                <p *ngIf="Role.Name =='Manager'"
                                                    style="font-size: 16px; color: #88AD47;" class="mb-0">
                                                    Manager <br> Access to the associated facility</p>
                                                <p *ngIf="Role.Name =='Preparer'"
                                                    style="font-size: 16px; color: #88AD47;" class="mb-0">
                                                    Preparer <br> Access to the associated facility</p>
                                                <!-- <p style="font-size: 16px; color: #88AD47;" *ngIf="Role.Name == 'Approver'">
                                            Approver</p> -->

                                            </div>

                                        </ng-container>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="" *ngIf="this.selectedRole !== Roleaccess &&(loginInfo.role === 'Super Admin' ||loginInfo.role === 'Admin')"> -->
                            <div
                                *ngIf="selectedRole == '9782f1b1-27ba-4a5c-861c-94174d73d471' || selectedRole == '8f7e334f-db30-44d6-a3d6-a1d12b29547c'">
                                <p class="mt-3 text-dark">Select Facility</p>

                                <div class="text-light noData" *ngIf="facilitydata === true">
                                    <div class="icon mt-3">
                                        <i class="fa fa-info-circle" style="font-size: 20px" aria-hidden="true"></i>
                                    </div>
                                    <label class="text-center label">No facilities available. Start by
                                        adding a new facility using the add
                                        facility button form facility.</label>
                                </div>
                                <p-dropdown
                                    class=" finput ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                                    placeholder="Select" name="facility" #facility="ngModel" [options]="facilityList"
                                    (onShow)="handleDropdownShow()" (onHide)="handleDropdownHide()"
                                    optionLabel="AssestType" optionValue="id" styleClass="facilitydropdown"
                                    [(ngModel)]="admininfo.facilityID" (ngModelChange)="onChangeFacilityId()">
                                </p-dropdown>

                            </div>
                            <div *ngIf="selectedRole == '525debfd-cd64-4936-ae57-346d57de3585'" class="">
                                <p class="mt-3 text-dark">Select Group</p>

                                <div class="text-light noData" *ngIf="facilitydata === true">
                                    <div class="icon mt-3">
                                        <i class="fa fa-info-circle" style="font-size: 20px" aria-hidden="true"></i>
                                    </div>
                                    <label class="text-center label">No facilities available. Start by
                                        adding a new facility using the add
                                        facility button form facility.</label>
                                </div>
                                <p-dropdown
                                    class=" finput ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                                    placeholder="Select" name="facility" #facility="ngModel" [options]="facilityList"
                                    (onShow)="handleDropdownShow()" (onHide)="handleDropdownHide()" optionLabel="name"
                                    styleClass="facilitydropdown" optionValue="id" [(ngModel)]="admininfo.group_id"
                                    (ngModelChange)="onChangeFacilityId()">
                                </p-dropdown>

                            </div>
                        </div>
                        <!-- <div style="height: 80px;"></div> -->
                        <div class="mt-2 ct_user_add_modal_btn pt-2">
                            <Button (click)="removeCss()" type="submit" *ngIf="FormEdit === false" [disabled]="
                                    (this.selectedRole !== Roleaccess &&
                                        facilitydata === true) ||
                                    usernameIsExist === true ||
                                    emailIstExist === true
                                " class="rounded span-color px-3 text-white text-style loading ct_animation_btn_121">
                                <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                                Save
                            </Button>
                            <Button *ngIf="FormEdit === true" type="submit "
                                class="rounded span-color px-3 text-white text-style ct_animation_btn_121">
                                <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                                Update
                            </Button>

                            <button type="button" class="closebutton ml-3" (click)="onCloseHandled()"
                                (click)="removeCss()" [disabled]="isloading">
                                Close
                            </button>
                        </div>
                    </form>
                </div>
            </p-dialog>
            <ng-container *ngIf="admininfoList.length >0">
                <div class="row mx-2 overflow-auto Updateuser rounded ct_user_box_light_green_bg11"
                    *ngFor="let user of admininfoList" (click)="selectUser(user)" (click)="UnlockComplete(user.user_id)"
                    [ngClass]="{colorchange: unlock == user.user_id}">

                    <div class="col pt-2 d-flex text-style">
                        <div class="mt-3">
                            <span *ngIf="user.role === 'Manager'"
                                class="span-color border rounded-circle d-flex align-items-center justify-content-center px-3 py-2 text-white">M</span>
                            <span *ngIf="user.role === 'Admin'"
                                class="span-color border rounded-circle px-3 py-2">A</span>
                            <span *ngIf="user.role === 'Preparer'"
                                class="span-color border rounded-circle d-flex align-items-center justify-content-center px-3 py-2 text-white">P</span>
                            <span *ngIf="user.role === 'Approver'"
                                class="span-color border rounded-circle d-flex align-items-center justify-content-center px-3 py-2 text-white">A</span>
                            <span *ngIf="user.role === 'Super Admin'"
                                class="span-color border rounded-circle d-flex align-items-center justify-content-center px-3 py-2 text-white">S</span>
                            <span *ngIf="user.role === 'Auditor'"
                                class="span-color border rounded-circle d-flex align-items-center justify-content-center px-3 py-2 text-white">AU</span>
                        </div>
                        <div class="ml-3 font-pera">
                            <p>
                                {{ user.username }}<br />{{ user.role }}<br />
                                {{ user.email }}
                            </p>
                        </div>
                    </div>
                    <div class="col d-flex justify-content-end">
                        <div class=" span-color border rounded Role-box ointer">
                            <p *ngIf="user.group_name;else haveGroup"
                                class="text-limit text-white ct_line_height_26 mb-0" style="height: 26px;"
                                title="{{ user.group_name }}">
                                {{ user.group_name | slice: 0:maxCharacters
                                }}{{
                                user.group_name?.length > maxCharacters
                                ? '...'
                                : ''
                                }}
                            </p>
                            <ng-template #haveGroup>
                                <p class="text-limit text-white ct_line_height_26 mb-0" style="height: 26px;"
                                    title="{{ user.facilityName }}">
                                    {{ user.facilityName | slice: 0:maxCharacters
                                    }}{{
                                    user.facilityName?.length > maxCharacters
                                    ? '...'
                                    : ''
                                    }}
                                </p>

                            </ng-template>
                        </div>
                    </div>
                </div>

            </ng-container>
        </div>
        <div class="col-5" [ngClass]="this.updatedtheme === 'dark' ? 'User-tabD' : 'User-tabL'">
            <div class="row mt-3 align-items-center">
                <div class="col p-2 d-flex align-items-center">
                    <!-- <div class="">
                        <img class="border rounded-circle" [src]="uploadedImageUrl" alt="" />
                    </div> -->
                    <div class="ml-3 font-pera ">
                        <p class="mb-0">
                            {{ loginInfo.companyName }}<br />
                            {{ loginInfo.companyEmail }}
                        </p>
                    </div>
                </div>
                <div class="col d-flex justify-content-end  text-white text-style ">
                    <div>
                        <span class="span-color ct_super_admin_btn12 text-white font-UserProfile rounded-pill px-2">
                            {{ loginInfo.role }}
                        </span>
                    </div>
                </div>
            </div>

            <h5 class="pl-3 mt-3">User Profile</h5>
            <div class="row font-UserProfile mt-4">
                <table class="table ct_billing_border_0_none">
                    <tr>
                        <td>
                            <p class="mb-0">Name :</p>
                        </td>
                        <td>

                            <p class="mb-0">
                                {{ userdetails?.firstname }} {{ userdetails?.lastname }}
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p class="mb-0">Email :</p>
                        </td>
                        <td>
                            <p class="mb-0">{{ userdetails?.email }}</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p class="mb-0">Role :</p>
                        </td>
                        <td>
                            <p class="mb-0">{{ userdetails?.role }}</p>
                        </td>
                    </tr>
                    <ng-container *ngIf="userdetails?.role !== 'Super Admin'">
                        <tr *ngIf="!userdetails?.group_name;else haveGroup">
                            <td>
                                <p class="mb-0">Facility:</p>
                            </td>
                            <td>
                                <p class="mb-0">{{ userdetails?.facilityName }}</p>
                            </td>
                        </tr>
                        <ng-template #haveGroup>
                            <tr>
                                <td>
                                    <p class="mb-0">{{ userdetails.is_main_group == 1 ? 'Main Group' : 'Sub Group' }}
                                    </p>
                                </td>
                                <td>
                                    <p class="mb-0">{{ userdetails?.group_name }}</p>
                                </td>
                            </tr>

                        </ng-template>

                    </ng-container>
                </table>
                <!-- <div class="col-5 ml-3">
                    <p>Name :</p>
                    <p>Email :</p>
                    <p>Role :</p>
                    <p>Facility:</p>
                </div>
                <div class="col-6">
                    <p *ngIf="userdetails.role === 'Super Admin'">
                        {{ loginInfo.companyName }}
                    </p>
                    <p>
                        {{ userdetails.firstname }} {{ userdetails.lastname }}
                    </p>

                    <p>{{ userdetails.email }}</p>
                    <p>{{ userdetails.role }}</p>
                    <p>{{ userdetails.facilityName }}</p>
                </div> -->
            </div>
            <div class="d-flex text-light text-style font-pera mb-2  ml-3 pb-3" *ngIf="userdetails">
                <div>
                    <i *ngIf="userdetails.isDisabledEdit !== true"
                        class="LocButtonEdit pi pi-user-edit pointer d-flex text-white" style="border-radius: 10px;"
                        (click)="EditUser(userdetails)">
                        <p class="pl-2 ">Edit</p>
                    </i>
                </div>
                <div class="form-group has-search text-light pointer">
                    <i *ngIf="userdetails.isDisabledDelete !== true" (click)="deleteUser($event, userdetails.user_id)"
                        class="deleteButton pi pi-trash pointer d-flex text-white">
                        <p class="pl-2 ">Delete</p>
                    </i>
                </div>
            </div>
        </div>
    </div>
</div>